import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import HeaderPageTitle from "../../../layouts/inc/HeaderPageTitle";
import useTranslations from "../../../i18n/useTranslations";
import { usePageContent } from "../../../i18n/useContentMap";

import img_icoTh from "../../../assets/img/ci/profile/ico-th.svg";
import img_icoEn from "../../../assets/img/ci/profile/ico-en.svg";

const Language = () => {
  const stateProfile = useSelector((state) => state.profile);
  const navigate = useNavigate();
  const { t, lang, setLang, getAvailableLanguages, isLoading } = useTranslations();
  const content = usePageContent("language");

  // State สำหรับเก็บภาษาที่เลือก
  const [selectedLanguage, setSelectedLanguage] = useState(lang || "th");
  const [isChanging, setIsChanging] = useState(false);

  /* Handle goto page */
  const handleGotoPage = (e) => {
    e.preventDefault();
    const page = e.currentTarget.dataset.page;
    navigate("/" + page);
  };

  /* Handle language selection */
  const handleLanguageSelect = async (language) => {
    if (language === selectedLanguage || isChanging) return;

    setIsChanging(true);
    setSelectedLanguage(language);

    try {
      // ใช้ i18n system เพื่อเปลี่ยนภาษา
      await setLang(language);

      // แสดง feedback ให้ผู้ใช้ทราบ
      const languageName = language === "th" ? content.thai : content.english;
      console.log(`${content.changeSuccess}: ${languageName}`);

      // อาจจะเพิ่ม toast notification ที่นี่
      // showNotification(`${content.changeSuccess}: ${languageName}`, 'success');
    } catch (error) {
      console.error("Error changing language:", error);
      // Rollback selection on error
      setSelectedLanguage(lang);

      // Show error notification
      // showNotification(`${content.error}: ${error.message}`, 'error');
    } finally {
      setIsChanging(false);
    }
  };

  /* First event render */
  useEffect(() => {
    // ตรวจสอบว่ามี profile หรือไม่
    if (Object.getOwnPropertyNames(stateProfile.dataUser).length === 0) {
      navigate("/");
    }

    // ตั้งค่าภาษาปัจจุบันจาก i18n state
    if (lang) {
      setSelectedLanguage(lang);
    }
  }, [navigate, stateProfile.dataUser, lang]);

  // Get available languages from i18n config
  const availableLanguages = getAvailableLanguages();

  // Language icon mapping
  const languageIcons = {
    th: img_icoTh,
    en: img_icoEn,
  };

  return (
    <>
      <Helmet>
        <title>{content.title} - Paypoint</title>
        <meta name="title" content={`${content.title} - Paypoint`} />
        <meta name="description" content={content.selectLanguage} />
        <meta name="keyword" content="language, ภาษา, paypoint" />
        <meta property="og:title" content={`${content.title} - Paypoint`} />
        <meta property="og:description" content={content.selectLanguage} />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pageLanguage">
        <main>
          <div className="wrapContent">
            <HeaderPageTitle title={content.title} prevPage="/profile" />

            <section id="pLanguage">
              <div className="bLangSelect">
                <h2>{content.selectLanguage}</h2>

                {isLoading ? (
                  <div className="loading-container">
                    <p>{content.loading}</p>
                  </div>
                ) : (
                  availableLanguages.map((language) => (
                    <div
                      key={language.code}
                      className={`bMenu ${selectedLanguage === language.code ? "active" : ""} ${isChanging ? "changing" : ""}`}
                      onClick={() => handleLanguageSelect(language.code)}
                      style={{
                        cursor: isChanging ? "not-allowed" : "pointer",
                        opacity: isChanging && selectedLanguage !== language.code ? 0.6 : 1,
                      }}
                    >
                      <div className="bIcon">
                        <img src={languageIcons[language.code]} alt={`${language.name} Flag`} />
                        <p>{language.name}</p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
};

export default Language;
